"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _axios = _interopRequireDefault(require("axios"));
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
var _formateData = _interopRequireDefault(require("./formateData"));
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const fetchList = requestPort => {
  return (0, _axios.default)({
    method: 'post',
    url: `/render/api/configsolution/${requestPort}`,
    data: {
      page_index: 1,
      page_size: 3
    }
  }).then(({
    data
  }) => {
    var _data$event_item;
    return (data === null || data === void 0 ? void 0 : (_data$event_item = data.event_item) === null || _data$event_item === void 0 ? void 0 : _data$event_item.map(o => o.fields)) || [];
  }).catch(e => console.log(e, 'error::'));
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  if (data) {
    const _ref = data,
      _ref$modTitle = _ref.modTitle,
      modTitle = _ref$modTitle === void 0 ? '' : _ref$modTitle,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
      desc = _ref.desc,
      flexSmallTitle = _ref.flexSmallTitle,
      mergeComponentStatus = _ref.mergeComponentStatus,
      _ref$cardList = _ref.cardList,
      cardList = _ref$cardList === void 0 ? [] : _ref$cardList,
      upcoming = _ref.upcoming,
      ongoing = _ref.ongoing,
      finished = _ref.finished,
      activityType = _ref.activityType;
    const _React$useState = React.useState(cardList),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      mkData = _React$useState2[0],
      setMkData = _React$useState2[1];
    if (!cardList.length) {
      React.useEffect(() => {
        fetchList('getListLiveEvent').then(result => {
          if ((result === null || result === void 0 ? void 0 : result.length) < 3) {
            fetchList('getListPastEvent').then(res => {
              const dataList = [...result, ...res.slice(0, 3 - result.length)];
              setMkData((0, _formateData.default)(dataList, {
                upcoming,
                ongoing,
                finished,
                activityType
              }));
            });
          } else if (result) {
            setMkData((0, _formateData.default)(result, {
              upcoming,
              ongoing,
              finished,
              activityType
            }));
          }
        });
      }, []);
    }
    // 处理组件背景色
    const bgStyle = backgroundColor ? (0, _componentUtils.doComponentsBgColorEvent)(backgroundColor) : {};
    // 其他参数
    const outParams = {
      flexTitle: modTitle,
      desc,
      flexSmallTitle,
      mergeComponentStatus
    };
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_marketCard', componentKey, modTitle])), /*#__PURE__*/React.createElement(_intlDesignUi.MarketCard, Object.assign({
      cardList: mkData
    }, outParams, {
      style: backgroundColor ? bgStyle : {}
    })));
  }
  return /*#__PURE__*/React.createElement("div", null);
}